import { Modal } from "react-bootstrap"
import ButtonClose from "./ButtonClose"

const ModalDanoAccidental = (props) => {

    const handleClose = () => props.close(false)

    return (
        <>
            <Modal show={props.show} onHide={handleClose} size="xl" centered>
                <Modal.Body className="p-0">
                    <ButtonClose close={handleClose} />
                    <div className='modal__groups pb-5 p-0'>
                        <div className="modal__group" style={{ borderColor: 'var(--azul)' }}>
                            <div className="cob__card-ico_container-mov-modal">
                                <img  style={{width:'35px'}} src='/assets/img/homeout/dano-accidental/ico-dano.png' alt="imagen cob icono" />
                            </div>
                            <div className="modal__descripcion">
                                <h1 className="color_morado_light my-5">Daño accidental</h1>
                                <p>Si tu equipo celular sufre un daño accidental, lo repararemos o reemplazaremos por uno con características similares nuevo o re-acondicionado cubriendo hasta dos (2) eventos al año. Para conocer más sobre los términos y condiciones de esta cobertura consulta las condiciones generales y tu certificado de cobertura.</p>
                            </div>
                        <div className="modal__descripcion">
                                <h3>¿En qué casos no te protege tu seguro?</h3>
                                <ul className="list__modal" style={{'color':'black'}}>
                                    <li className="d-flex">Daños no accidentales, daños cubiertos por la garantía del equipo, daños causados por el mal uso del equipo, desgaste normal, detalles físicos que no afecten su funcionalidad, presencia de virus o pérdidas de software y/o apps.</li>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalDanoAccidental